import { call, put, select } from 'redux-saga/effects';
import { setAttributes, getAttributesFail } from '../../ducks/attributesSlice';
import { requestGetAttributes } from '../requests/attributes';
export const getProducts = (state) => state.products;

export function* handleGetAttributes(action) {
	try {
		const product = yield select(getProducts);
		if (product.filters) {
			const response = yield call(requestGetAttributes, product.filters);
			const { data } = response;
			if (data.attributes) {
				let attritubes = data?.attributes.map(function (element) {
					return { ...element, show_more: false, showHide: false };
				});
				data.attributes = attritubes;
			}
			yield put(setAttributes({ ...data }));
		}
	} catch (error) {
		yield put(
			getAttributesFail({ message: error.message, response: error.response })
		);
	}
}
